<template>
  <v-row no-gutters class="header-row">
    <v-col class="left-container" md="6" xs="6">
      <v-btn class="first-button" rounded="pill" @click="goToEspaceFournisseur()">
        <span class="button-label">ESPACE FOURNISSEURS</span>
      </v-btn>
      <v-btn class="second-button" rounded="pill" @click="goToEspaceAcheteur()">
        <span class="button-label">ESPACE ACHETEURS</span>
      </v-btn>
    </v-col>
    <v-col class="right-container" md="6" xs="6">
      <v-btn class="login-button" rounded="pill" @click="this.$router.push('/login')" v-if="!userName">
        <span class="button-label">SE CONNECTER</span>
      </v-btn>
      <v-menu anchor="bottom end" rounded content-class="user-dropdown" v-else>
        <template v-slot:activator="{ props }">
          <div class="user-trigger" v-bind="props">
            <span class="username">{{ userName }}</span>
            <div class="user-avatar">{{ userInitials }}</div>
          </div>
        </template>
        <v-card class="dropdown-card" elevation="4">
          <v-card-text class="pa-0">
            <div class="dropdown-header">
              <div class="dropdown-avatar">{{ userInitials }}</div>
              <h3 class="dropdown-name">{{ userName }}</h3>
            </div>
            <v-divider></v-divider>
            <div class="dropdown-actions">
              <button class="dropdown-btn" @click="this.$router.push('/search/save/list')">
                Mon Espace
              </button>
              <v-divider></v-divider>
              <button class="dropdown-btn dropdown-btn--logout" @click="logout()">
                Me Déconnecter
              </button>
            </div>
          </v-card-text>
        </v-card>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import { LOGIN_ROUTE, ESPACE_FOURNISSEURS_ROUTE, ESPACE_ACHETEURS_ROUTE } from '@/router/routes';
import { GET_USER, IS_USER_AUTHENTICATED } from '@/store/storeconstants';

export default {
  name: 'WelcomeVIew',
  data() {
    return {
      showMenu: false,
      userName: localStorage.getItem('userName') || null,
      ESPACE_FOURNISSEURS_ROUTE,
      ESPACE_ACHETEURS_ROUTE
    };
  },
  computed: {
    userInitials() {
      if (!this.userName) return '';
      return this.userName
        .split(' ')
        .map(n => n[0])
        .slice(0, 2)
        .join('')
        .toUpperCase();
    },
    user() {
      return this.$store.getters[`auth/${GET_USER}`];
    },
    isAuthenticated() {
      return this.$store.getters[`auth/${IS_USER_AUTHENTICATED}`];
    },
  },
  methods: {
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      localStorage.removeItem('userName');
      this.userName = null;
      this.$router.push(LOGIN_ROUTE);
    },
    goToEspaceFournisseur() {
      this.$router.push(ESPACE_FOURNISSEURS_ROUTE);
    },
    goToEspaceAcheteur() {
      this.$router.push(ESPACE_ACHETEURS_ROUTE);
    }
  },
}
</script>

<style scoped>
.header-row {
  width: 100%;
  min-height: 3.5rem;
  flex-shrink: 0;
  background: #304353;
  margin-top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14.71rem;
}

.left-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
}

.right-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.first-button,
.second-button {
  height: 2rem !important;
  padding: 0 1.1rem !important;
  flex-shrink: 0;
  border-radius: 2rem !important;
}

.first-button {
  background-color: #DCC6A5 !important;
}

.second-button {
  background: #F3F0E9 !important;
}

.login-button {
  height: 2rem !important;
  padding: 0 1.4rem !important;
  border-radius: 2rem !important;
  background: #DCC6A5 !important;
}

.button-label {
  color: #304353;
  font-family: Rubik-Regular, sans-serif;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.03em;
}

/* User trigger (username + avatar) */
.user-trigger {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.3rem 0.5rem;
  border-radius: 2rem;
  transition: background 0.2s;
}

.user-trigger:hover {
  background: rgba(255, 255, 255, 0.1);
}

.username {
  color: white;
  font-family: Rubik-Regular, sans-serif;
  font-size: 0.85rem;
  font-weight: 500;
}

.user-avatar {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  background-color: #DCC6A5;
  color: #304353;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Rubik-Regular, sans-serif;
  font-size: 0.8rem;
  font-weight: 700;
  border: 2px solid rgba(255, 255, 255, 0.4);
  flex-shrink: 0;
  user-select: none;
}

/* Dropdown card */
.dropdown-card {
  min-width: 200px;
  margin-top: 0.5rem;
  border-radius: 0.75rem !important;
  overflow: hidden;
}

.dropdown-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.25rem 1rem 1rem;
  gap: 0.5rem;
}

.dropdown-avatar {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: #DCC6A5;
  color: #304353;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Rubik-Regular, sans-serif;
  font-size: 1.1rem;
  font-weight: 700;
}

.dropdown-name {
  font-family: Rubik-Regular, sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  color: #304353;
  text-align: center;
}

.dropdown-actions {
  display: flex;
  flex-direction: column;
}

.dropdown-btn {
  padding: 0.75rem 1rem;
  text-align: center;
  font-family: Rubik-Regular, sans-serif;
  font-size: 0.875rem;
  color: #304353;
  background: none;
  border: none;
  cursor: pointer;
  transition: background 0.15s;
  width: 100%;
}

.dropdown-btn:hover {
  background: #f5f0e8;
}

.dropdown-btn--logout {
  color: #c0392b;
}

.dropdown-btn--logout:hover {
  background: #fdf2f0;
}

/* ── Responsive breakpoints ── */

@media (max-width: 1400px) {
  .header-row {
    padding: 0 5rem;
  }
}

@media (max-width: 1100px) {
  .header-row {
    padding: 0 2rem;
  }
}

@media (max-width: 900px) {
  .header-row {
    padding: 0 1.25rem;
  }
  .username {
    display: none;
  }
}

@media (max-width: 680px) {
  .header-row {
    flex-direction: column;
    align-items: stretch;
    padding: 0.5rem 1rem;
    gap: 0.4rem;
  }

  .left-container,
  .right-container {
    justify-content: center;
    width: 100%;
  }

  .first-button,
  .second-button,
  .login-button {
    flex: 1;
  }
}
</style>
